export default "__VITE_ASSET__T00YwrgD__"